import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Typography,
  Button,
  Paper, 
  Card, 
  Stack, 
  Divider, 
  CardHeader, 
  IconButton
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from '../common/components/LocalizationProvider';
import MainToolbar from '../main/MainToolbar';
import Container from '@mui/material/Container';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import {ReactComponent as WheelIcon} from '../resources/images/track2you/Icons_Volante.svg';
import {ReactComponent as TimerIcon} from '../resources/images/track2you/Icons_Clock.svg';
import {ReactComponent as HammersIcon} from '../resources/images/track2you/Icons_Hammers.svg';
import {ReactComponent as UserIcon} from '../resources/images/track2you/Icons_User_Outline.svg';
import {ReactComponent as InfoIcon} from '../resources/images/track2you/Icons_Info.svg';
import {ReactComponent as NotificationIcon} from '../resources/images/track2you/Icons_Notification.svg';
import WorkStyles from './utils/WorkStyles';
import { refreshTotalCounts } from  './utils/refreshTotalCountsUtils';
import { useTimer } from "./utils/TimerUtils"; // Import the timer utility
import { refreshDriverInstructions } from './utils/refreshDriverInstructionsUtils'; // Import your utility function
import LoadingPage from '../LoadingPage';  // Adjust the path based on your directory structure
import CustomAlert from "./CustomAlert"; // Import the timer utility




const WorkPage = () => {
  const classes = WorkStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const t = useTranslation();
  const driverInstructions = useSelector((state) => state.session.driverInstructions);
  const totalCounts = useSelector((state) => state.session.totalCounts);
  const devices = useSelector((state) => state.session.device);
  const user = useSelector((state) => state.session.user);
  
  const [loading, setLoading] = useState(true);
  const [showAlert, setShowAlert] = useState(false);
  let sumOfCounts = 0;

  if(driverInstructions?.at(-1)){
    const lastInstructionDate = new Date(driverInstructions?.at(-1).dateTime);
    const now = new Date();
    const timeDifferenceSeconds = Math.floor((now - lastInstructionDate) / (60 * 1000));  // Difference in seconds
    sumOfCounts += timeDifferenceSeconds;
  }

  const maxTimers = totalCounts?.[0]
  ? totalCounts[0].work + totalCounts[0].driving + totalCounts[0].pause + totalCounts[0].other
  : 0;

    useEffect(() => {
    if (
      user &&
      devices &&
      devices.length > 0 &&
      driverInstructions &&
      totalCounts &&
      totalCounts.length > 0
    ) {
      setLoading(false);
    } else {
      console.log("Waiting for all required data to load...");
    }
  }, [devices, user, driverInstructions, totalCounts]);


   // Timer formatted time
   const formattedTime = useTimer(totalCounts, driverInstructions?.at(-1)?.dateTime || null);

    // Function to calculate percentage
    const calculatePercentage = (value) => {
      if (!totalCounts || maxTimers === 0) {
        return 0; // No total counts or all counters are zero
      }
      if (value === 0 && driverInstructions?.at(-1).operationType==1) {
        return 100; // Total counts exist but value is zero
      }
      return (value * 100) / maxTimers;
    };
 
  
  // State to keep track of the selected item
  const [selectedItem, setSelectedItem] = useState(null);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#CFD3E1' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: 'center',
    color: '#CFD3E1',
    borderRadius: '20px',
    width: '26%',
    fontSize: '9pt',
  }));

  const handleShowAlert = () => setShowAlert(true);
  const handleCloseAlert = () => setShowAlert(false);

  const sendDriverInstruction = async (operationType, itemName) => {
    setSelectedItem(itemName);

    const instruction = {
        userId: user.id,
        deviceId: devices[0]?.id,  // Optional chaining for safety
        operationType: operationType,
        dateTime: new Date().toISOString(),
    };

    try {
        const response = await fetch('/api/driver-instructions/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(instruction),
        });

        if (!response.ok) {
            throw new Error('Failed to register instruction');
        }

        // Ensure both calls run sequentially and handle their promises correctly
        await refreshDriverInstructions(user, dispatch);
        await refreshTotalCounts(user, dispatch);

        console.log('Instruction registered and data refreshed successfully');
    } catch (error) {
        localStorage.setItem('driverInstructions', JSON.stringify(instruction));

        // Ensure both calls run sequentially and handle their promises correctly
        await refreshDriverInstructions(user, dispatch);
        await refreshTotalCounts(user, dispatch);
    }
};


  if (loading) {
      return <LoadingPage message="Loading..." />;
  }else{
    /*if(!devices || devices.length==0){
      return (
        <div className={classes.root}>
        <Paper square elevation={3} className={classes.header}>
          <MainToolbar />
        </Paper>
        <Container>
          <LoadingPage message="Não possui nenhum dispositivo associado" />
        </Container>
        </div>
    )};*/
  }


    return (
      <div className={classes.root}>
        <Paper square elevation={3} className={classes.header}>
          <MainToolbar />
        </Paper>
        <Container className={classes.mainContainer}>
          <Typography className={classes.leftTitle} variant="h5" component="h5">
            Área de <br />trabalho
          </Typography>
            
        <div className={classes.notificationsDiv}>
          <Button 
            className={classes.notificationsButton} 
            variant="contained"
            onClick={(event) => navigate('/settings/notifications')}>
              <NotificationIcon />
          </Button>
        </div>
        {/* Custom Alert Component */}
        {showAlert && (
          <CustomAlert text="Ainda não fez 15 minutos de Pausa" 
          open={showAlert} onClose={handleCloseAlert} />
        )}
        
  
        </Container>
        <Container className={classes.graphContainer}>
        {
          // DRIVING GRAPH
        }
        <CircularProgress
          variant="determinate"
          className={classes.grayGraph}
          size={200}
          thickness={1.6}
          value={100} // Static maximum graph
        />
        <CircularProgress
          variant="determinate"
          className={classes.workGraph}
          size={200}
          thickness={1.6}
          value={totalCounts ? calculatePercentage(totalCounts?.[0]?.driving || 0) : 0} // Dynamic driving percentage
          color="primary"
        />

        {
          // WORK GRAPH
        }
        <CircularProgress
          variant="determinate"
          className={classes.grayGraph}
          size={175}
          thickness={1.6}
          value={100} // Static maximum graph
        />
        <CircularProgress
          variant="determinate"
          className={classes.pauseGraph}
          size={175}
          thickness={1.6}
          value={totalCounts ? calculatePercentage(totalCounts?.[0]?.work || 0) : 0} // Dynamic work percentage
          color="primary"
        />
  
        <div className={classes.timer}>
          <Typography className={classes.fimTrabalho} variant="subtitle2" component="div">
            Fim <br />Trabalho
            <Typography className={classes.typographyTimer} variant="h6">
              {formattedTime ? formattedTime : '00:00'}
            </Typography>
          </Typography>
        </div>        
        </Container>
        <div className= {classes.timersUnderline}>
          <Card className={classes.timerCard}>
            <WheelIcon />
            
          </Card>
          <Typography className={classes.fimTrabalho} variant="subtitle2" component="div">
          {totalCounts?. [0]? totalCounts[0].drivingHours:0}
          </Typography>
          <Card className={classes.timerCard2}>
            <HammersIcon />
          </Card>
          <Typography className={classes.fimTrabalho} variant="subtitle2" component="div">
          {totalCounts?. [0]? totalCounts[0].workingHours:0}
          </Typography>
        </div>
  
        <Container>
            <Typography className={classes.fasesTrabalho} variant="h6" component="h6">
              Fases de Trabalho
            </Typography>
          <Typography className={classes.fimTrabalho} variant="subtitle2" component="div">
            Escolha a fase de trabalho que pretende iniciar
          </Typography>
        </Container>
        {(devices!=null && devices?.[0] ) && (
          <Stack className={classes.stackFasesTrabalho} direction="row" spacing={2}>
          <Item 
            className={driverInstructions!=null &&
               driverInstructions.length!=0 &&
                driverInstructions?.at(-1).operationType==1  ?
                 classes.selectedItem : ''}
            onClick={(!sumOfCounts && sumOfCounts<15) ? () => handleShowAlert() :
               (devices!=null && devices?.[0] ) && 
              (driverInstructions==null || driverInstructions.length==0 ||
                   (driverInstructions?.at(-1).operationType==2 &&
                    sumOfCounts>15))
              ? () => sendDriverInstruction(1, 'trabalho'):null}
            sx={{
              backgroundColor: (devices==null || !devices?.[0] )? 'red' : '',
              color: (devices==null || !devices?.[0] )? '#fff' : ''
            }}
          >
              <WheelIcon className={classes.stackImageIcon} />
              <Typography variant="subtitle1" component="div">
                {(devices==null || !devices?.[0] )? 'Dispositivo' : 'Trabalho'}
              </Typography>
              <Divider sx={{borderColor: '#fff'}}/>
              {(devices==null || !devices?.[0] ) && (
                <span>Dispositivo não encontrado</span>
              )}
              {(devices!=null && devices?.[0] ) && (
                <span>Condução <br /> Outros trabalhos</span>
              )}
            </Item>
            <Item 
              className={(driverInstructions!=null && driverInstructions.length!=0 && driverInstructions?.at(-1).operationType==2) ? classes.selectedItem : ''}
              onClick={(driverInstructions==null || driverInstructions.length==0 || driverInstructions?.at(-1).operationType!=2) ? () => sendDriverInstruction(2, 'pausa') : null}
            >
              <TimerIcon className={classes.stackImageIcon} />
              <Typography variant="subtitle1" component="div">
                Pausa
              </Typography>
              <Divider />
              <span>Intervalos <br /> Pausas</span>
            </Item>
            <Item 
              className={driverInstructions!=null && driverInstructions.length!=0 && driverInstructions?.at(-1).operationType==3 ? classes.selectedItem : ''}
              onClick={driverInstructions==null || driverInstructions.length==0 ||
                 driverInstructions?.at(-1).operationType!=3
                 && (driverInstructions?.at(-1).operationType==2 && sumOfCounts>15)
                 ? () => sendDriverInstruction(3, 'outro') :
                 (driverInstructions?.at(-1).operationType==2 && sumOfCounts<15) ? () => handleShowAlert() :  null}
            >
              <UserIcon className={classes.stackImageIcon} />
              <Typography variant="subtitle1" component="div">
                Outro
              </Typography>
              <Divider />
              <span>Outros<br /> Outros</span>
            </Item>
          </Stack>
        )}
        {(devices==null || !devices?.[0] ) && (
          <Card className={classes.useInstructions} >
            <CardHeader
              className={classes.useInstructionsHeader}
              title="DISPOSITIVO NÃO ENCONTRADO"
            />
          </Card>
        )}
  
        <Card className={classes.useInstructions} >
          <CardHeader
            className={classes.useInstructionsHeader}
            avatar={
              <InfoIcon className={classes.useInstructionsIcon} />
            }
            action={
              <IconButton aria-label="more">
                <ArrowOutwardIcon />
              </IconButton>
            }
            title="Instruções de Utilização"
          />
        </Card>
  
      </div>
    );
  
};

export default WorkPage;
